import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const crossfadeDurationMs = 225;
const tokens = combineTokens("--circuit", {
  segmentWidth: units.px(10),
  offset: 0,
  pointX: 0,
  pointY: 0
});
const root = "_35srvbjpml";
const scroller = "_35ss912ea9";
const toggle = "_35st15z9rcl";
const transitionWrapper = "_35stlr5coo";
const wrapper = "_35swim81kc";
const circuit = "_35scbo6ypx";
const item = "_35si4q4728";
function getPointOnCircle(t) {
  const deg = t * 360 - 90;
  const rad = deg * (Math.PI / 180);
  return {
    x: 0.5 + 0.5 * Math.cos(rad),
    y: 0.5 + 0.5 * Math.sin(rad)
  };
}

export { circuit, crossfadeDurationMs, getPointOnCircle, item, root, scroller, toggle, tokens, transitionWrapper, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
